import React from 'react'
import { connect } from 'react-redux'
import { Grid, Card, CardContent, Button, Dialog, DialogTitle, DialogContent, DialogActions, Typography } from '@material-ui/core'
import { makeStyles } from '@material-ui/core/styles';
import CheckCircleOutlineOutlinedIcon from '@material-ui/icons/CheckCircleOutlineOutlined';
import CheckCircleIcon from '@material-ui/icons/CheckCircle';

const useStyles = makeStyles((theme) => ({
    card: {
        marginBottom: '10px',
        borderRadius: '20px',
        border: `1px dashed ${theme.palette.text.secondary}`,
        cursor: 'pointer'
    },
    row: {
        display: 'flex',
        flexDirection: 'row',
        alignItems: 'center',
        '& >*': {
            marginRight: theme.spacing(1)
        }
    },
    marginBottom: {
        marginBottom: theme.spacing(2)
    },
}));


const OffersPopUp = (props) => {

    const [state, setState] = React.useState({
        selected: null,
        promoCodeData: {},
        error: null,
        errorMsg: '',
    })
    const classes = useStyles()

    const { onClose, isOpen, price, isCheckOut, promoCodes } = props

    function setSelected(item) {
        if (isCheckOut) {
            setState(current => {
                return {
                    ...current,
                    selected: item.promoCode,
                    promoCodeData: item
                }
            })
        }
    }

    function onApply() {
        if (!Boolean(state.selected)) {
            setState(current => {
                return {
                    ...current,
                    error: true,
                    errorMsg: 'select a promo code'
                }
            })
            return
        }

        const { promoCodeData } = state

        if (promoCodeData.minimumOrder > 0 && price < promoCodeData.minimumOrder) {
            setState(current => {
                return {
                    ...current,
                    error: true,
                    errorMsg: `Not applicable, minimun order must be ₹${promoCodeData.minimumOrder}`
                }
            })
            return
        } else if (promoCodeData.typeOfDiscount === 'NUMBER') {
            let newPrice = price
            newPrice = Number(price) - Number(promoCodeData.discountValue)

            newPrice = newPrice <= 0 ? 0 : newPrice

            // call the function
            props.onSelect(promoCodeData.promoCode, promoCodeData.id, promoCodeData.discountValue)

        } else if (promoCodeData.typeOfDiscount === 'PERCENTAGE') {
            let newPrice = price
            let percentageToNum = Number(price) * Number(promoCodeData.discountValue) / 100
            if (percentageToNum > Number(promoCodeData.maxDiscount)) {
                percentageToNum = promoCodeData.maxDiscount
            }
            newPrice = Number(price) - Number(percentageToNum)

            newPrice = newPrice <= 0 ? 0 : newPrice

            // call the function
            props.onSelect(promoCodeData.promoCode, promoCodeData.id, percentageToNum)

        }

        setState({
            selected: null,
            promoCodeData: {},
            error: null,
            errorMsg: '',
        })

        onClose()

    }

    return (
        <Dialog
            // fullWidth
            open={isOpen}
            onClose={onClose}
            aria-labelledby="Deals Pop Up"
            aria-describedby="Deals Pop Up"
        >
            <DialogTitle>
                <Typography component="span" variant="h5" align="left" color="primary">
                    <strong>All Available Deals</strong>
                </Typography>
            </DialogTitle>
            <DialogContent>
                {state.error && <Typography component="p" variant="body1" color="error">{state.errorMsg}</Typography>}
                {
                    promoCodes.map(item => {
                        return (
                            <Card key={item.id} id={item.id} variant="outlined" className={classes.card} onClick={() => setSelected(item)}>
                                <CardContent>
                                    <Grid container spacing={2}>
                                        <Grid item xs={1}>
                                            {
                                                item.promoCode === state.selected ? < CheckCircleIcon color="secondary" /> : <CheckCircleOutlineOutlinedIcon />
                                            }
                                        </Grid>
                                        <Grid item item xs={11}>
                                            <Typography component="p" variant="h6">
                                                {item.promoCode}
                                            </Typography>
                                            {item.typeOfDiscount === 'NUMBER' &&
                                                <Typography component="p" variant="body1">
                                                    Get flat ₹{item.discountValue} discount
                                                    {item.minimumOrder === 0 ? ' (no minimum order)' : ` on minimun order of ₹ ${item.minimumOrder}`}
                                                </Typography>
                                            }
                                            {item.typeOfDiscount === 'PERCENTAGE' &&
                                                <Typography component="p" variant="body1">
                                                    Get {item.discountValue}% discount upto ₹{item.maxDiscount}
                                                    {item.minimumOrder === 0 ? ' (no minimum order)' : ` on minimun order of ₹ ${item.minimumOrder}`}
                                                </Typography>
                                            }
                                        </Grid>
                                    </Grid>
                                </CardContent>
                            </Card>
                        )
                    })
                }
                {state.error && <Typography component="p" variant="body1" color="error">{state.errorMsg}</Typography>}

            </DialogContent>

            <DialogActions>
                <Button onClick={onClose} color="primary">
                    Close
                </Button>
                {
                    isCheckOut && <Button variant="contained" color="secondary" onClick={onApply}>
                        Apply
               </Button>
                }
            </DialogActions>
        </Dialog>
    )

}

const mapStateToProps = (state) => {
    const promoCodes = state.promoCodes
    const promoCodesArray = Object.keys(promoCodes).map(key => promoCodes[key])
    return {
        promoCodes: promoCodesArray
    }
}

export default connect(mapStateToProps, {})(OffersPopUp)